<template>
  <div class="banner-bg">
    <div class="zy-container ">
<!--      style="min-height: 79vh;"-->
      <div class="row" >
        <div class="col-xl-5">
          <h3 class="title">{{ slider.title }}</h3>
          <p class="desc">{{ slider.desc }}</p>
          <div class="join" @click="handleLogin">立即加入</div>
        </div>
        <div class="img-bar ">
          <img draggable="false" :src="slider.image" alt="" style="width: 100%"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slider: Object,
    data: Object
  },
  data() {
    return {}
  },
  methods: {
    handleLogin() {
      this.$router.push("/login");
    }
  }
}
</script>


<style scoped lang="scss">
.banner-bg {
  background-image: url(../../../assets/images/index/banner/banner5.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 664px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 664px;
  .title {
    font-size: 40px;
    font-weight: bold;
    color: #fff;
    line-height: 65px;
    letter-spacing: 2px;
    margin-bottom: 28px;
  }


  .col-xl-5 {
    width: 50%;
    padding-right: 9%;
  }

  .img-bar {
    width: 53%;
    margin-top: 4%;
  }

  .desc {
    font-size: 17px;
    font-weight: 400;
    color: #fff;
    line-height: 32px;
    letter-spacing: 1px;
  }

}


.join {
  margin-top: 20px;
  font-size: 16px;
  background-image: linear-gradient(to right, #404DFF, #918BFF ) !important;
  border: none;
  width: 124px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  color: #FFFFFF;
  outline: none;
  border-radius: 6px;
  cursor: pointer;
}
</style>
